module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village/levelIcon//7_Platinum.png?v=800b35b8";